module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1260.dd7ef05e.png";